"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAppClientProps = getAppClientProps;
exports.AppClient = AppClient;
exports.renderClient = renderClient;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var _reactRouterDom = require("react-router-dom");

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _after = require("@whys/after");

var _appcache = require("@whys/appcache");

var _Root = require("./Root");

var _appcontainer = require("./appcontainer");

var _plugins = require("./plugins");

var _serialization = require("./helpers/serialization");

// our library
// local
// import { NotFound } from './UI/NotFound';
function readCookie(name, defaultValue) {
  var val = _jsCookie["default"].get(name);

  return val === undefined ? defaultValue : val;
}

function getAppClientProps(_x) {
  return _getAppClientProps.apply(this, arguments);
}

function _getAppClientProps() {
  _getAppClientProps = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee(options) {
    var routes, plugins, containerConfig, createContainerContext, AppRoot, createPluginContext, enableSSR, enableDEBUG, djreactState, initialData, csrftoken, appCacheInitialData, appCache, pluginCtx, pluginData, pluginProps, ctx, appContainer, appRootProps, routeData;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            routes = options.routes, plugins = options.plugins, containerConfig = options.containerConfig, createContainerContext = options.createContainerContext, AppRoot = options.AppRoot, createPluginContext = options.createPluginContext; // NotePrototype(simon): how to handle?

            enableSSR = true;
            enableDEBUG = process.env.NODE_ENV !== 'production';

            djreactState = function () {
              var defaultValue = {
                render: 'client',
                debug: true,
                version: '?',
                language: 'en',
                device: 'desktop',
                logged: false,
                env: 'production',
                errors: ['reading from DOM failed']
              };
              var el = document.getElementById('djreact-state');

              if (!el) {
                return defaultValue;
              }

              try {
                var val = (0, _serialization.loadData)(el.textContent);
                return (0, _objectSpread2["default"])({}, defaultValue, val);
              } catch (error) {
                // output error only if we expect SSR
                if (enableSSR) {
                  console.error(error);
                }
              }

              return defaultValue;
            }();

            initialData = function () {
              var el = document.getElementById('djreact-init-data');

              if (!el) {
                return null;
              }

              try {
                return (0, _serialization.loadData)(el.textContent);
              } catch (error) {
                return null;
              }
            }();

            csrftoken = readCookie('csrftoken', ''); //
            // App cache
            //

            appCacheInitialData = function () {
              var defaultValue = {};
              var appstateEl = document.getElementById('unstated-app-state');

              if (!appstateEl) {
                return defaultValue;
              }

              try {
                return (0, _serialization.loadData)(appstateEl.textContent);
              } catch (error) {
                // output error only if we expect SSR
                if (enableSSR) {
                  console.error(error);
                }
              }

              return defaultValue;
            }();

            appCache = (0, _appcache.createAppCache)(); //
            // Plugins
            //

            if (!createPluginContext) {
              _context.next = 14;
              break;
            }

            _context.next = 11;
            return createPluginContext({
              appCache: appCache,
              djreactState: djreactState,
              initialData: initialData,
              csrftoken: csrftoken
            });

          case 11:
            _context.t0 = _context.sent;
            _context.next = 15;
            break;

          case 14:
            _context.t0 = {};

          case 15:
            pluginCtx = _context.t0;
            _context.next = 18;
            return (0, _plugins.createPluginData)(plugins, {
              isServer: false,
              ctx: pluginCtx
            });

          case 18:
            pluginData = _context.sent;
            pluginProps = (0, _plugins.collectPluginProps)(plugins, pluginData); //
            // App container
            //

            _context.next = 22;
            return createContainerContext({
              csrftoken: csrftoken,
              appCache: appCache,
              djreactState: djreactState,
              initialData: initialData,
              pluginProps: pluginProps
            });

          case 22:
            ctx = _context.sent;
            _context.next = 25;
            return (0, _appcontainer.createAppContainer)(containerConfig, ctx);

          case 25:
            appContainer = _context.sent;
            // step: load serialized initial data
            appCache.loadAll(appCacheInitialData);

            if (enableDEBUG) {
              window.appCache = appCache;
              window.appContainer = appContainer;
            }

            _context.next = 30;
            return AppRoot.getInitialProps({
              appCache: appCache,
              djreactState: djreactState,
              appContainer: appContainer
            });

          case 30:
            appRootProps = _context.sent;
            _context.next = 33;
            return (0, _after.ensureReady)(routes);

          case 33:
            routeData = _context.sent;
            return _context.abrupt("return", {
              routeData: routeData,
              appRootProps: appRootProps,
              djreactState: djreactState,
              pluginData: pluginData,
              plugins: plugins,
              AppRoot: AppRoot,
              routes: routes,
              appCache: appCache,
              appContainer: appContainer
            });

          case 35:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getAppClientProps.apply(this, arguments);
}

function AppClient(props) {
  var _React$useState = _react["default"].useState(null),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      redirectInfo = _React$useState2[0],
      setRedirectInfo = _React$useState2[1];

  var performRedirect = function performRedirect(redirectInfo) {
    setRedirectInfo(redirectInfo);
  };

  var routeData = props.routeData,
      appRootProps = props.appRootProps,
      djreactState = props.djreactState,
      pluginData = props.pluginData,
      plugins = props.plugins,
      AppRoot = props.AppRoot,
      routes = props.routes,
      appCache = props.appCache,
      appContainer = props.appContainer;
  return _react["default"].createElement(_Root.Root, {
    djreactState: djreactState,
    pluginData: pluginData,
    plugins: plugins
  }, _react["default"].createElement(AppRoot, appRootProps, _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_after.After, {
    data: routeData,
    routes: routes,
    appCache: appCache,
    djreactState: djreactState,
    appContainer: appContainer,
    performRedirect: performRedirect
  }), redirectInfo ? _react["default"].createElement(_reactRouterDom.Redirect, {
    to: redirectInfo.to
  }) : null)));
}

function renderClient(_x2) {
  return _renderClient.apply(this, arguments);
}

function _renderClient() {
  _renderClient = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee2(options) {
    var props, hydrateOrRender;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getAppClientProps(options);

          case 2:
            props = _context2.sent;
            hydrateOrRender = props.djreactState.render === 'client' ? _reactDom.render : _reactDom.hydrate;
            hydrateOrRender(_react["default"].createElement(_reactRouterDom.BrowserRouter, null, _react["default"].createElement(AppClient, props)), // $FlowFixMe
            document.getElementById('root'));

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _renderClient.apply(this, arguments);
}